export default __webpack_public_path__ + "d2082505cae4359f113c6755781b3964.png";